import { forEach } from "lodash";
/** 设置显示模式 */
export function setMode(mode) {
  if (mode) {
    document.documentElement.setAttribute('theme', 'dark')
  } else {
    document.documentElement.removeAttribute('theme')
  }
}
// 获取当前模式
// export function getMode() {
//   if (document.documentElement.hasAttribute('theme')) {
//     return false
//   } else {
//     return true
//   }
// }

/** 版本比较 */
export function compareVersion(version1, version2) {
  if (version1 === '' || version2 === '') {
    throw new Error('版本号不能为空')
  }
  const arr1 = version1.split('.')
  const arr2 = version2.split('.')
  const length1 = arr1.length
  const length2 = arr2.length
  let minlength = Math.min(length1, length2)
  let i = 0
  for (i; i < minlength; i++) {
    let a = parseInt(arr1[i]) || 0
    let b = parseInt(arr2[i]) || 0
    let diff = a - b
    if (diff !== 0) {
      return diff > 0 ? 1 : -1
    }
  }
  if (length1 === length2) {
    return 0
  } else if (length1 > length2) {
    for (let j = i; j < length1; j++) {
      if (parseInt(arr1[j]) !== 0) {
        return 1
      }
    }
    return 0
  } else {
    for (let j = i; j < length2; j++) {
      if (parseInt(arr2[j]) !== 0) {
        return -1
      }
    }
    return 0
  }
}

export function changeURLArg(obj) {
  const query = location.search.substr(1);
  let queryObj = {};
  if (query) {
    forEach(query.split('&'), (item) => {
      let tempArr = item.split('=');
      queryObj[tempArr[0]] = tempArr[1];
    });
  }
  queryObj = { ...queryObj, ...obj };

  const newQuery = Object.keys(queryObj)
    .filter((key) => queryObj[key])
    .map((key) => `${key}=${queryObj[key]}`)
    .join('&');

  history.replaceState('', '', `${location.pathname}?${newQuery}#/`);
}

let TP_SERVER_DOMAIN;

if (process.env.VUE_APP_ENV === 'production') {
    TP_SERVER_DOMAIN = 'https://preserver.mytokenpocket.vip';
}
else if (process.env.VUE_APP_ENV === 'beta') {
    TP_SERVER_DOMAIN = 'https://betaserver.mytokenpocket.vip';
}
else if (process.env.VUE_APP_ENV === 'dev') {
    TP_SERVER_DOMAIN = 'https://testserver.mytokenpocket.vip';
}

export { TP_SERVER_DOMAIN }
